import { render, staticRenderFns } from "./InterTable.vue?vue&type=template&id=15233bdc&scoped=true"
import script from "./InterTable.vue?vue&type=script&lang=js"
export * from "./InterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15233bdc",
  null
  
)

export default component.exports